import i18n from "./i18n";

const roles = {
    USER:{
        value: 5,
        key: "user"
    },
    SERVER:{
        value: 10,
        key: "server"
    },
    CASHIER:{
        value: 13,
        key: "cashier"
    },
    BAROWNER:{
        value: 15,
        key: "barowner"
    },
    ADMIN:{
        value: 20,
        key: "admin"
    },
    SUPERADMIN:{
        value: 30,
        key: "superadmin"
    }
}

const orderStatusOptions = [
    { label: i18n.t('completed'), value: 'completed' },
    { label: i18n.t('ready'), value: 'ready' },
    { label: i18n.t('processing'), value: 'processing' },
    { label: i18n.t('in_queue'), value: 'confirmed' },
    { label: i18n.t('pending'), value: 'pending' },
];

const orderTypeOptions = [
    { label: i18n.t('dine_in'), value: 'dine_in' },
    { label: i18n.t('take_away'), value: 'take_away' },
]
const paymentTypeOptions = [
    { label: i18n.t('payrexx'), value: 'payrexx' },
]
const currencyTypeOptions = [
    { label: 'CHF', value: 'CHF' },
]

const defaultVAT = [
    { value: 0 },
    { value: 2.1 },
    { value: 8.6 },
]

const defaultTable = [
    { value: "1" },
    { value: "2" },
    { value: "3" },
    { value: "4" }
]
const tableLimitOptions=[
    {label:"10",value:10},
    {label:"25",value:25},
    {label:"50",value:50},
    {label:"100",value:100}
]
const printerTypes=[
    {label:"Epson",value:"epson"}
]

const sevenSegmentDisplayTypes = [
    { label: 'ALLNET', value: 'allnet' },
]

const paymentTypes = {
    CASH: {
        key: "cash",
        value: i18n.t('cash')
    },
    CARD: {
        key: "card",
        value: i18n.t('card')
    },
    TWINT: {
        key: "twint",
        value: i18n.t('twint')
    },
    PAYREXX: {
        key: "payrexx",
        value: i18n.t('payrexx')
    },
    ONLINE: {
        key: "online",
        value: i18n.t('online')
    }
};

const paymentMethods = {
    TWINT: {
        key: "twint",
        value: i18n.t('twint')
    },
    PAYREXX: {
        key: "payrexx",
        value: i18n.t('payrexx')
    },
}

const consumptionRoundingTypes=[
    {label:"Quantity",value:"quantity"},
    {label:"Input",value:"input"}
]

const consumptionRoundingOptions=[
    {label:"1",value:1},
    {label:"0.05",value:0.05},
    {label:"0.1",value:0.1},
    {label:"0.5",value:0.5},
]

const constants = {
    applicationName: 'Kestuboua'
}

const primaryColors ={
    background : "#F0F0F0",
    blue : "#2065d1",
    white : "#ffffff"
}

const consumptionColors = [
    {id: null, name: i18n.t('colors.none'), colorCode: null},
    {id: 'purple', name: i18n.t('colors.purple'), colorCode: '#a269ff80'},
    {id: 'red', name: i18n.t('colors.red'), colorCode: '#ff5436cc'},
    {id: 'orange', name: i18n.t('colors.orange'), colorCode: '#ffcd81'},
    {id: 'gray', name: i18n.t('colors.gray'), colorCode: '#a6a4a3'},
    {id: 'green', name: i18n.t('colors.green'), colorCode: '#6dc778'},
]

export default {
    // baseUrl: '/api',    //live
    baseUrl: process.env.REACT_APP_BASE_URL,
    appBaseUrl: process.env.REACT_APP_USER_APP_BASE_URL,
    tokenKey: 'token',
    roles: roles,
    roleKey: 'role',
    orderStatusOptions: orderStatusOptions,
    currencyCode: 'CHF',
    version: '2.0.82',
    defaultVAT: defaultVAT,
    defaultTable:defaultTable,
    orderTypeOptions,
    paymentTypeOptions,
    currencyTypeOptions,
    constants,
    primaryColors,
    tableLimitOptions,
    printerTypes,
    sevenSegmentDisplayTypes,
    paymentTypes,
    paymentMethods,
    consumptionRoundingTypes,
    consumptionRoundingOptions,
    consumptionColors
}